import AnnualPeriodsError from './AnnualPeriodsError';
class AnnualPeriodsPropertyNotHaveBricks extends AnnualPeriodsError {
    propertyId;
    constructor(propertyId, options) {
        super('The number of bricks is more than the available', options);
        this.propertyId = propertyId;
    }
}
export default AnnualPeriodsPropertyNotHaveBricks;
